<template>
  <div class="">
    <p class="text">正在启动微信支付，请稍后。。。<br><br>若未弹出支付功能请重新下单或与云柑社区客服联系。</p>
    <wx-config v-on:wxConfigReady="wxConfigReady" />
  </div>
</template>

<script>
import wxConfig from '@/components/weixin/wxConfig'
import { integralRecharge } from '@/api/wallet/integral'
import { cashRecharge } from '@/api/wallet/cash'
import { getPaySignInfo } from  '@/api/pay/payApi'
export default {
  components:{
    wxConfig,

  },
  data(){
    return {
      wxPay: {},
    }
  },
  created(){
    this.wxPay = this.session('wxPay')
    console.log(this.wxPay)
    this.wxPay.wxCase = this.session('wxCase') || 1; // 1为 云柑社区，2为 探真学院
  },
  methods: {
    // wxConfig配置成功后
    wxConfigReady(){
      window.setTimeout(()=>{
        if(this.wxPay.wxPayType==='现金充值'){
          this.cashRecharge()
        }else if(this.wxPay.wxPayType==='云柑金币充值'){
          this.integralRecharge()
        }else if(this.wxPay.wxPayType==='直播流量充值'){
          this.getPaySignInfo(0)
        }else if(this.wxPay.wxPayType==='知识商城购物'){
          this.getPaySignInfo(1)
        }else if(this.wxPay.wxPayType==='店铺会员礼包'){
          this.getPaySignInfo(2)
        }else if(this.wxPay.wxPayType==='省购商城购物'){
          this.getPaySignInfo(3)
        }
      },200)
    },

    // 充值金币
    integralRecharge(){
      let _this = this;
      integralRecharge(this.wxPay).then(res=>{
        let { data } = res;
        if(data.sign){
          window.wx.chooseWXPay({
            timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
            package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: data.sign, // 支付签名
            success: function (res) {// 支付成功后的回调函数
              // console.log(res)
              _this.$toast('充值成功！')
              _this.removeSession('wxPay')
              _this.$router.go(-2)
            }
          });
        }else {
          this.$toast(res.message)
        }
      })
    },

    // 现金充值
    cashRecharge(){
      let _this = this;
      cashRecharge(this.wxPay).then(res=>{
        let { data } = res;
        if(data.sign){
          window.wx.chooseWXPay({
            timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
            package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: data.sign, // 支付签名
            success: function (res) {// 支付成功后的回调函数
              console.log(res)
              _this.$toast('充值成功！')
              _this.removeSession('wxPay')
              _this.$router.go(-2)
            }
          });
        }else {
          this.$toast(res.message)
        }
      })
    },

    // 购买 商品 、 直播点卡
    getPaySignInfo(orderType){ // orderType： 0：直播流量，1：商城知识商品
      let _this = this;
      getPaySignInfo(this.wxPay).then(res=>{
        let { data } = res;
        if(data.sign){
          window.wx.chooseWXPay({
            timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
            package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: data.sign, // 支付签名
            success: function (res) {// 支付成功后的回调函数
              // console.log(res)
              if(orderType===0){
                _this.$toast('充值成功！')
                _this.removeSession('wxPay')
                _this.$router.go(-2)
              }else if(orderType===1){
                _this.$toast('付款成功！')
                _this.removeSession('wxPay')
                _this.$router.replace('/mall/paymentResults')
              }else if(orderType===2){
                _this.$toast('付款成功！')
                let url = '/mall/mallShopMember?shopId=' + _this.wxPay.shopId + '&isBuy=ok';//isBuy 判断是否刚刚购买完成显示"购买成功"
                if(_this.wxPay.inviteUserId){
                  url = url + '&inviteUserId=' +_this.wxPay.inviteUserId
                }
                _this.removeSession('wxPay')
                _this.$router.replace(url)
              }else if(orderType===3){
                _this.$toast('付款成功！')
                _this.removeSession('wxPay')
                let obj = Object.assign({}, (_this.session('sgConfirmOrderPay')||{}))
                obj.totalAmount = 0
                _this.session('sgConfirmOrderPay', obj)
                _this.$store.commit('my/change_sgOrderType', 2)
                _this.$router.replace('/sg/sgOrderPayOK')
              }
            }
          });
        }else {
          this.$toast(res.message)
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.text{
  text-align: center;font-size: 12px;padding: 24px 0;color: #999;
}
</style>